import { TFunction } from 'i18next';

export function getMaxValueMessage(t: TFunction) {
	return ({ max }: { max: number }) => t('max_value', { max });
}
